import { BadgeFillDto, BadgeFillKind } from "services/menuItemBadges/restModels";

// Горизонтальный слева направо — с такого градиента («Хит») бейджи в меню и начались.
export const DEFAULT_GRADIENT_ANGLE_DEG = 90;

export const GRADIENT_ANGLE_OPTIONS: { angleDeg: number; label: string }[] = [
    { angleDeg: 90, label: "→" },
    { angleDeg: 180, label: "↓" },
    { angleDeg: 135, label: "↘" },
    { angleDeg: 45, label: "↗" },
];

export const solidFill = (colorFrom: string): BadgeFillDto => ({
    kind: "Solid",
    colorFrom,
    colorTo: null,
    angleDeg: null,
});

export const withFillKind = (fill: BadgeFillDto, kind: BadgeFillKind): BadgeFillDto =>
    kind === "Solid"
        ? solidFill(fill.colorFrom)
        : {
              kind,
              colorFrom: fill.colorFrom,
              colorTo: fill.colorTo || fill.colorFrom,
              angleDeg: fill.angleDeg ?? DEFAULT_GRADIENT_ANGLE_DEG,
          };

// Значение для CSS background: и плашка витрины, и превью кабинета рисуются одинаково.
export const fillToCss = (fill: BadgeFillDto): string => {
    if (fill.kind === "Gradient" && fill.colorTo) {
        return `linear-gradient(${fill.angleDeg ?? DEFAULT_GRADIENT_ANGLE_DEG}deg, ${fill.colorFrom}, ${fill.colorTo})`;
    }

    return fill.colorFrom;
};

// Относительная яркость sRGB — без гаммы: для выбора между белым и почти чёрным хватает.
const luminance = (hex: string): number => {
    const value = hex.replace("#", "");

    if (value.length !== 6) return 1;

    const r = parseInt(value.slice(0, 2), 16) / 255;
    const g = parseInt(value.slice(2, 4), 16) / 255;
    const b = parseInt(value.slice(4, 6), 16) / 255;

    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

/*
* Подсказка цвета текста — по средней яркости остановок градиента. Выбирать по одной из них
* нельзя: у пары «тёмный → светлый» любой из двух цветов текста читается на своём конце плашки
* и теряется на другом, поэтому среднее — наименее плохой вариант, а не точный ответ. Это
* именно подсказка: в форме её можно переопределить.
* */
export const suggestTextColor = (fill: BadgeFillDto): string => {
    const stops = fill.kind === "Gradient" && fill.colorTo
        ? [luminance(fill.colorFrom), luminance(fill.colorTo)]
        : [luminance(fill.colorFrom)];

    const average = stops.reduce((sum, item) => sum + item, 0) / stops.length;

    return average > 0.6 ? "#1A1A1A" : "#FFFFFF";
};
